import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AvatarBauhausComponent } from '../avatar-bauhaus/avatar-bauhaus.component';
import { AvatarBeamComponent } from '../avatar-beam/avatar-beam.component';
import { AvatarMarbleComponent } from '../avatar-marble/avatar-marble.component';
import { AvatarPixelComponent } from '../avatar-pixel/avatar-pixel.component';
import { AvatarRingComponent } from '../avatar-ring/avatar-ring.component';
import { AvatarSunsetComponent } from '../avatar-sunset/avatar-sunset.component';

export type AvatarType = 'bauhaus' | 'beam' | 'marble' | 'pixel' | 'ring' | 'sunset';

@Component({
  selector: 'lib-avatar',
  imports: [
    AvatarBauhausComponent,
    AvatarBeamComponent,
    AvatarMarbleComponent,
    AvatarPixelComponent,
    AvatarRingComponent,
    AvatarSunsetComponent,
  ],
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarComponent {
  @Input({ required: true }) type!: AvatarType;
  @Input({ required: true }) colors!: string[];
  @Input({ required: true }) name!: string;
  @Input() inputSize = 40;
}
